import { useEffect, useState } from 'react';

type Countdown = {
    days: string;
    hours: string;
    minutes: string;
};

function pad2(value: number): string {
    return value.toString().padStart(2, '0');
}

function parseRuDateTime(dateTimeStr: string): Date {
    // "DD.MM.YYYY HH:mm"
    const [datePart, timePart] = dateTimeStr.split(' ');
    const [dayStr, monthStr, yearStr] = datePart.split('.');
    const [hourStr, minuteStr] = timePart.split(':');

    const day = Number(dayStr);
    const month = Number(monthStr) - 1; // месяцы 0–11
    const year = Number(yearStr);
    const hour = Number(hourStr);
    const minute = Number(minuteStr);

    return new Date(year, month, day, hour, minute, 0, 0);
}

type DiffResult = {
    totalDays: number;
    totalHours: number;
    totalMinutes: number;
};

function diffFromNow(target: Date): DiffResult {
    const now = new Date();
    let diffMs = target.getTime() - now.getTime();

    if (diffMs < 0) diffMs = 0;

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
    const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return {
        totalDays,
        totalHours,
        totalMinutes,
    };
}

export function useCountdown(dateTimeStr: string): Countdown {
    const [state, setState] = useState<Countdown>(() => {
        const target = parseRuDateTime(dateTimeStr);
        const { totalDays, totalMinutes } = diffFromNow(target);
        const daysNum = totalDays;
        const hoursNum = Math.floor((totalMinutes - daysNum * 24 * 60) / 60);
        const minutesNum = totalMinutes - daysNum * 24 * 60 - hoursNum * 60;

        return {
            days: pad2(daysNum),
            hours: pad2(hoursNum),
            minutes: pad2(minutesNum),
        };
    });

    useEffect(() => {
        const target = parseRuDateTime(dateTimeStr);

        const update = () => {
            const { totalDays, totalMinutes } = diffFromNow(target);
            const daysNum = totalDays;
            const hoursNum = Math.floor((totalMinutes - daysNum * 24 * 60) / 60);
            const minutesNum = totalMinutes - daysNum * 24 * 60 - hoursNum * 60;

            setState({
                days: pad2(daysNum),
                hours: pad2(hoursNum),
                minutes: pad2(minutesNum),
            });
        };

        update();
        const timerId = window.setInterval(update, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [dateTimeStr]);

    return state;
}
